import { createReducer } from '../../store.model';
import { TemplateMode } from '../core/template-definition.model';
import { createEmpty, createEmptyData } from '../scorecard.model';

import {
    ActionType,
    ReloadTabs,
    SelectTab,
    SelectUser,
    SelectUserResult,
} from './sc-header.action';
import {
    defaultScorecardHeaderState,
    ScorecardHeaderState,
    ScorecardTabShallow,
} from './sc-header.state';

const { reducer, builder } = createReducer<ActionType, ScorecardHeaderState>(
    defaultScorecardHeaderState(),
);

builder.add<ReloadTabs>(
    ActionType.SCORECARD_HEADER__RELOAD_TABS,
    (state, action) => {
        const nextTabs: ScorecardTabShallow[] = [];
        action.payload.tabs.forEach((e) => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, @typescript-eslint/consistent-type-assertions
            const prevTab =
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                (state.tabs && state.tabs.find((ee) => ee.tabId === e.tabId)) ||
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({} as ScorecardTabShallow);

            nextTabs.push({
                tabId: e.tabId,

                // TODO revise. should header component fetch user info or parent component? to be safe parent, but it doesn't look like other components will need it
                userId: e.userId,
                user: e.user,

                tabLabel: `${e.user.firstName} ${e.user.lastName}`,
                displayOrder: e.displayOrder,
                pending: e.pending.reload,
                hasData: prevTab.hasData || false,
                managerName: prevTab.managerName,
                numberOfDays: prevTab.numberOfDays,
                siteName: prevTab.siteName,
                periodStartDate: prevTab.periodStartDate,
                periodEndDate: prevTab.periodEndDate,
                isManager: prevTab.isManager,
            });
        });
        const nextSelectedTab = state.selectedTab
            ? nextTabs.find((e) => e.tabId === state.selectedTab.tabId)
            : undefined;
        return {
            ...state,
            tabs: nextTabs,
            selectedTab: nextSelectedTab,
        };
    },
);

builder.add<SelectTab>(
    ActionType.SCORECARD_HEADER__SELECT_TAB,
    (state, action) => {
        const selectedTab = action.payload.tab;
        const tabIndex = selectedTab
            ? state.tabs.findIndex((e) => e.tabId === action.payload.tab.tabId)
            : -1;
        let tab: ScorecardTabShallow;
        if (tabIndex !== -1) {
            const header =
                (selectedTab.selectedScorecard
                    ? selectedTab.selectedScorecard.header
                    : null) || createEmpty();
            const data =
                (selectedTab.selectedScorecard
                    ? selectedTab.selectedScorecard.data
                    : null) || createEmptyData();
            tab = state.tabs[tabIndex] = {
                ...state.tabs[tabIndex],
                pending: action.payload.tab.pending.reload,
                hasData: header.scorecardId != null && data.scorecardId != null,
                managerName: header.managerName,
                numberOfDays: header.numberOfDays,
                siteName:
                    header.siteName ||
                    header.siteShortName ||
                    header.siteInitials,
                periodStartDate: header.startDate,
                periodEndDate: header.endDate,
                isManager: data.templateConfig
                    ? data.templateConfig.mode === TemplateMode.MANAGER
                    : true,
            };
        }
        return {
            ...state,
            selectedTab: tab,
        };
    },
);

builder
    .add<SelectUser>(
        ActionType.SCORECARD_HEADER__SELECT_USER,
        (state, action) => {
            return {
                ...state,
                userSelectOpts: {
                    open: true,
                    userId: action.payload.userId,
                },
            };
        },
    )
    .add<SelectUserResult>(
        ActionType.SCORECARD_HEADER__SELECT_USER_RESULT,
        (state, action) => {
            return {
                ...state,
                userSelectOpts: {
                    open: false,
                    userId: action.payload.userId,
                    user: action.payload.user,
                },
            };
        },
    );

export default {
    header: reducer,
};
